<ul role="list" class="space-y-2 text-sm">
  @for (item of service.observeItems() | async; track item) {
    <li class="w-full border-b pb-2 px-2 last:border-0">
      <ng-container *ngTemplateOutlet="itemElem; context: { item: item, ident: 0 }"></ng-container>
    </li>
  }
</ul>

<ng-template #itemElem let-item="item" let-ident="ident">
  <button
    class="cursor-pointer flex flex-row justify-between text-gray-700 hover:text-gray-800 w-full"
    (click)="service.filter(item)"
    [class.font-bold]="service.observeIsFacetFilterActive(item.facet, item.facetValue) | async"
    >
    <span class="truncate">{{ item.text | i18n }}</span>
    @if (showCount()) {
      <span
        class="inline-flex items-center rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800"
        >{{ item.count }}</span
        >
      }
    </button>
    @if (item.children.length > 0 && (service.observeIsFacetFilterActive(item.facet, item.facetValue) | async)) {
      <div class="pt-4">
        <ul role="list" class="space-y-2">
          @for (subitem of item.children; track subitem) {
            <li class="border-b pb-2 last:border-0" [ngClass]="'ml-' + (ident + 1) * 2">
              <ng-container *ngTemplateOutlet="itemElem; context: { item: subitem, ident: ident + 1 }"></ng-container>
            </li>
          }
        </ul>
      </div>
    }
    <!-- [checked]="item.isRefined" -->
  </ng-template>
